export const CANCEL = 'Cancel';
export const CONTINUE = 'Continue';
export const BACK = 'Back';
export const NEXT_UPLOAD = 'Upload';
export const NEXT_TAGGING = 'Tagging';
export const SUBMIT_CHANGES = 'SUBMIT CHANGES';
export const SUBMIT_UPLOAD = 'SUBMIT';
export const CHANGE_UPLOAD_PROJECT = 'CHANGE PROJECT';
